/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { GatewayFault } from "./GatewayFault";
import * as t from "io-ts";
import { enumType } from "@pagopa/ts-commons/lib/types";

export enum FaultCodeCategoryEnum {
  "GENERIC_ERROR" = "GENERIC_ERROR"
}

/**
 * A PaymentProblemJson-like type specific for the GetPayment and ActivatePayment operations.
 * Possible values of `detail_v2` are limited to faults pertaining to Nodo errors.
 */

// required attributes
const GatewayFaultPaymentProblemJsonR = t.interface({
  faultCodeCategory: enumType<FaultCodeCategoryEnum>(
    FaultCodeCategoryEnum,
    "faultCodeCategory"
  ),

  faultCodeDetail: GatewayFault
});

// optional attributes
const GatewayFaultPaymentProblemJsonO = t.partial({
  title: t.string
});

export const GatewayFaultPaymentProblemJson = t.intersection(
  [GatewayFaultPaymentProblemJsonR, GatewayFaultPaymentProblemJsonO],
  "GatewayFaultPaymentProblemJson"
);

export type GatewayFaultPaymentProblemJson = t.TypeOf<
  typeof GatewayFaultPaymentProblemJson
>;
